<template>
  <div class="drinks">
    <el-row class="drink-title">
      <el-col :span="3">
        <span class="h3">{{$t('yin_pin_pei_fang')}}</span>
      </el-col>
      <el-col :span="21" class="drink-list-filter">
        <el-form label-width="auto" :inline="true" size="mini">
          <el-col :span="8" :offset="12">
            <el-form-item :label="$t('tiao_jian_sou_suo')">
              <el-input :placeholder="$t('qing_shu_ru_yin_pin_ming_cheng')" class="order-input-filter"
                        prefix-icon="el-icon-search" v-model="pagination.name" @change="loadDrinkSearch"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-button size="mini" class="drink-add" @click="handleDrinkCreate">{{$t('xin_zeng_yin_pin_pei_fang')}}</el-button>
          </el-col>

        </el-form>
      </el-col>
    </el-row>
    <div class="drink-data" v-if="drinkSyncs.length >0" v-loading.fullscreen.lock="isLoading">
      <el-row class="drink-data-list" :gutter="20" type="flex">
        <el-col :span="6" v-for="(drinkSync, index) in drinkSyncs" :key="index">
          <div class="drink-item" @click="handleEditDrink(drinkSync)">
            <img :src="imgs[drinkSync.imgIndex]"/>
            <p class="drink-item-text-info"> {{drinkSync.name}}</p>
          </div>
        </el-col>
      </el-row>

      <el-pagination
        @current-change="handleCurrentChange"
        class="pagination"
        :current-page="pagination.curPage"
        :page-size="pagination.limit"
        layout="total, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>
    <empty v-if="!isLoading && drinkSyncs.length ==0"></empty>

  </div>

</template>

<script>

  import Empty from '@/components/Empty'
  import {drinkSyncUnion, drinkSyncList, drinkSyncParam} from '@/api/delivery/device/drink'

  export default {
    name: '',
    components: {
      Empty,
    },
    activated: function () {
      this.loadDrinkSort()
    },
    data: function () {
      return {
        isLoading: false,
        pagination: {
          start: 0,
          curPage: 1,
          limit: 8,
          total: 0,
          name: ''
        },
        createDrinkSortVisible: false,
        drinkSyncs: [],
        imgs: [
          'http://img.dr-coffee.cn/drink/default/americano.png',
          'http://img.dr-coffee.cn/drink/default/barista.png',
          'http://img.dr-coffee.cn/drink/default/caffe_crema.png',
          'http://img.dr-coffee.cn/drink/default/caffe_latte.png',
          'http://img.dr-coffee.cn/drink/default/caffe_mocha.png',
          'http://img.dr-coffee.cn/drink/default/cappuccino.png',
          'http://img.dr-coffee.cn/drink/default/espresso.png',
          'http://img.dr-coffee.cn/drink/default/flat_white.png',
          'http://img.dr-coffee.cn/drink/default/french_vanilla.png',
          'http://img.dr-coffee.cn/drink/default/hot_chocolate.png',
          'http://img.dr-coffee.cn/drink/default/hot_water.png',
          'http://img.dr-coffee.cn/drink/default/iced_americano.png',
          'http://img.dr-coffee.cn/drink/default/latte_macchiato.png',
          'http://img.dr-coffee.cn/drink/default/lungo.png',
          'http://img.dr-coffee.cn/drink/default/macchiato.png',
          'http://img.dr-coffee.cn/drink/default/Mcnt.png',
          'http://img.dr-coffee.cn/drink/default/Me.png',
          'http://img.dr-coffee.cn/drink/default/milk.png',
          'http://img.dr-coffee.cn/drink/default/milk_foam.png',
          'http://img.dr-coffee.cn/drink/default/pot_coffee.png',
          'http://img.dr-coffee.cn/drink/default/regular_coffee.png',
          'http://img.dr-coffee.cn/drink/default/restretto.png',
          'http://img.dr-coffee.cn/drink/default/steam.png']
      }
    },
    filters: {},
    methods: {
      editDrinkSort(item) {
        this.$router.push({name: 'delivery.devices.drinkSorts', params: item})
      },
      createDrinkSort() {
        this.$refs.dsCreate.createDrinkSort()
      },
      handleCurrentChange(value) {
        this.pagination.curPage = value
        this.pagination.start = (value - 1) * this.pagination.limit
        drinkSyncList(this.pagination).then(res => {
          this.drinkSyncs = res.data || []
        })
      },
      handleEditDrink(drink) {
        if (drink.isSuccess === 0) {
          this.$router.push({name: 'delivery.devices.drinkSort.create', params: {drink: drink}})
          return
        }

        drinkSyncParam({uuid: drink.uuid}).then(res => {
          let drinks = res.data || []
          if (!drinks) {
            this.$router.back()
            return;
          }
          this.$router.push({
            name: 'delivery.devices.drinkSort.edit',
            params: {uuid: drink.uuid, drink: drinks, productUuid: drink.productUuid}
          })
        })
      },

      handleDrinkCreate() {
        this.$router.push({name: 'delivery.devices.drinkSort.create'})
      },
      closeDrinkSortVisible() {
        this.createDrinkSortVisible = false
        this.loadDrinkSort()
      },
      loadDrinkSort() {
        let vue = this
        vue.isLoading = true
        drinkSyncUnion(this.pagination).then(res => {
          vue.drinkSyncs = res.data.list || []
          vue.isLoading = false
          vue.pagination.total = parseInt(res.data.total)
        })
      },

      loadDrinkSearch() {
        let vue = this
        this.pagination.curPage = 1
        this.pagination.start = 0
        vue.isLoading = true
        drinkSyncUnion(this.pagination).then(res => {
          vue.drinkSyncs = res.data.list || []
          vue.pagination.total = parseInt(res.data.total)
          vue.isLoading = false
        })
      },
    },
  }
</script>

<style lang="scss">
  .drinks {
    padding: $padding $t-padding;
    display: flex;
    flex-direction: column;

    .drink-title {
      .drink-input-filter {
        input {
          border: none;
          border-bottom: 1px solid $f_fiv_color;
          font-size: $filter-font-size;
          border-radius: 0;
        }
      }

      .drink-add {
        background-color: $btn_color;
        border: none;
        color: $f_th_color;
      }
    }

    .drink-data {
      margin-bottom: $padding;

      .drink-data-list {
        flex-flow: row wrap;
        align-content: flex-start;

        .drink-item {
          background-color: $bg_sec_color;
          border: .2rem;
          margin-bottom: $padding;
          text-align: center;

          img {
            width: 100%;
            max-width: 160px;
            height: 100%;
            cursor: pointer;
          }

          .drink-item-text-info {
            padding: $padding-5;
            font-size: .6rem;
            color: $f_sec_color;
            text-align: center;

            span {
              cursor: pointer;
            }

            span:hover {
              color: $f_color;
            }

            .sync-device {
              margin-left: $padding-5;
              display: inline-block;
            }

            .delete-drink {
              margin-left: $padding-5;
              display: inline-block;
              color: $btn_sec_color;
            }
          }
        }
      }

      .pagination {
        text-align: center;
      }
    }
  }

</style>
